import { CHAT_USER, READ_CHAT, CREATE_CHAT, REMOVE_CHAT, CHAT_SEARCH} from './constants';
import { getPublicIP, getAuthHeader , setJWTToken, setUserInSession } from "../helpers/authHelper";
import { getReq , putReq, postReq} from './rest';
import { handleResponse , loader, pageloader } from './utils';

export const chatList = (chatList) => {
    return {
      type: CHAT_USER,
      chatList,
    };
};
export const getChatlist = (params = null) => {
    
    return (dispatch, getState) => {
      const bodyFormData = new FormData();
      const {login,chatsearch} = getState();
      bodyFormData.set('user_id', login.user.id);
      if((params.search != '') && (params.search != null)){
        bodyFormData.set('search_text', params.search);
      }
      bodyFormData.set('pagination',params.pagination);
      const headers = getAuthHeader();
      if((params.search == '') && (params.search == null)){
        if(params.pagination == 0){
          loader(true);
        }else{
          pageloader(true);
        }
      }else{
        if(params.pagination != 0){
          pageloader(true);
        }
      }
     
      postReq(`${apiURLPrefix}/chat/get_chatlist`, bodyFormData , headers)
      .then(handleResponse)
      .then((res) => {
        dispatch(chatList(res));
      }).catch((err)=>{
        console.log(err)
      }) 
    }  
};

export const readChat = (readChat) => {
    return {
      type: READ_CHAT,
      readChat,
    };
};
export const updateReadChat = (params = null) => {
   
    return (dispatch, getState) => {
      const bodyFormData = new FormData();
      const {login} = getState();
      bodyFormData.set('sender_id', params.sender_id);
      bodyFormData.set('receiver_id', login.user.id);
      const headers = getAuthHeader();
      postReq(`${apiURLPrefix}/chat/read_chat`, bodyFormData , headers)
      .then(handleResponse)
      .then((res) => {
       
        dispatch(readChat(params));
      }).catch((err)=>{
        console.log(err)
      }) 
    }  
}; 

export const createChat = (createChat) => {
  
  return {
    type: CREATE_CHAT,
    createChat,
  }; 
};
export const saveChat = (params = null) => {
 
  return (dispatch, getState) => {
    console.log('Heelo');
    console.log('Params : ',params);
    const bodyFormData = new FormData();
    const {login} = getState();
    console.log('Login');
    console.log('Login :::: ', login.user.id);
    bodyFormData.set('sender_id', login.user.id);
    bodyFormData.set('receiver_id', JSON.stringify([params.receiver_id]));
    bodyFormData.set('message', params.message);
    bodyFormData.set('date_time', params.date_time);
    bodyFormData.set('online_status','0');
    bodyFormData.set('media_link', params.media_link);
    bodyFormData.set('media_type', params.media_type);
    bodyFormData.set('firebase_timestamp', params.firebase_timestamp);
    
    const headers = getAuthHeader();
    console.log('Header ',headers);
    postReq(`${apiURLPrefix}/chat/create_chat`, bodyFormData , headers)
    .then(handleResponse)
      .then((res) => {
        
        dispatch(createChat(res));
      }).catch((err)=>{
        console.log(err)
      }) 
    }  
}; 
   

export const removeChat = (removeChat) => {
  return {
    type: REMOVE_CHAT,
    removeChat,
  };
};
export const deleteChat = (params = null) => {
 
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('sender_id', login.user.id);
    bodyFormData.set('receiver_id', params.receiver_id);
    bodyFormData.set('firebase_timestamp', params.firebase_timestamp);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/chat/delete_chat`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      Object.assign(res, {
        firebase_timestamp: params.firebase_timestamp
      })
      dispatch(removeChat(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};

export const chatSearch = (chatSearch) => {
  return {
    type: CHAT_SEARCH,
    chatSearch,
  };
};
export const updateChatSearch = (params = null) => {
  return (dispatch,getState) => {
      dispatch(chatSearch(params));
  }
};